import { render } from "./AuthorCompletePage.vue?vue&type=template&id=6c78df64&scoped=true&ts=true"
import script from "./AuthorCompletePage.vue?vue&type=script&lang=ts"
export * from "./AuthorCompletePage.vue?vue&type=script&lang=ts"

import "./AuthorCompletePage.vue?vue&type=style&index=0&id=6c78df64&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src454630497/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c78df64"]])

export default __exports__